<template>
  <div>
    <b-button
        :busy="saveAttachmentLoading"
        :disabled="this.checkedItems.length < 1"
        size="sm"
        type="uploadFile"
        variant="outline-primary"
        @click="openBatchUploadAttachmentModal"
    >{{ title }}
    </b-button>
    <ReBModal ref="batchUploadAttachment"
              :header="title"
              :ok-loading="uploading"
              @ok="submitQualityFilesChange">
      <multi-attachment :attachment-ids="attachmentIds"
                        :query-api="attachmentQueryApi"
                        class="w-100"
                        @idsChanged="changeAttachmentIds"
                        @uploadingChanged="changeUploading"
                        @loading="attachmentLoading"></multi-attachment>
    </ReBModal>
  </div>
</template>

<script>
import commonViewsUtil from "@/utils/commonViewsUtil";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import emCommonApiMixin from "@/mixin/em/common/api";
import EmUtils from "@/utils/emUtils";

export default {
  name: "BatchUploadAttachment",
  components: {MultiAttachment, ReBModal},
  mixins: [emCommonApiMixin],
  props: {
    modelName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "批量上传附件"
    },
    attachmentFieldName: {
      type: String,
      required: true
    },
    checkedItems: {
      type: Array,
      required: true
    },
    batchUploadUrl: {
      type: String,
      required: true
    },
    uploadUrl: {
      type: String,
      required: true
    },
    doQuery: {
      type: Function,
      default: null
    },
    voName: {
      type: String,
      default: 'rows'
    },
  },
  computed: {
    attachmentQueryApi() {
      return `${process.env.VUE_APP_SITHMES_PRD_URL}/${this.modelName}/getAttachmentList`;
    },
    checkedItemsVo() {
      return this.$store.state[this.modelName][`checkedItems${EmUtils.toCapFirst(this.voName)}`] || this.$store.state[this.modelName].checkedItems
    },
    selectedItems() {
      return this.$store.state[this.modelName][this.voName].filter(row => this.checkedItemsVo.indexOf(row.id) !== -1)
    },
  },
  data() {
    return {
      saveAttachmentLoading: false,
      attachmentIds: '',
      uploading: false,
    }
  },
  methods: {
    attachmentLoading(val) {
      this.$refs.batchUploadAttachment.changeLoading(val);
    },
    submitAttachmentChange() {
      this.saveAttachmentLoading = true;
      this.$_emApiMixin_put(this.uploadUrl, {
        ids: this.checkedItems,
        poReport: this.attachmentIds === undefined ? "" : this.attachmentIds
      }).then(() => {
        this.$message.success("保存成功");
        this.doQuery();
      }).finally(() => this.saveAttachmentLoading = false);
    },
    submitQualityFilesChange() {
      // OK 在上传中已被禁用，这里兜底：仍在上传时提交会丢掉新文件，单条记录还会清空已有附件
      if (this.uploading) {
        return
      }
      const originAttachmentIds = this.selectedItems[0][this.attachmentFieldName];
      if (!originAttachmentIds && !this.attachmentIds) {
        return
      }
      this.$_emApiMixin_put(this.batchUploadUrl, {
        entityIds: this.checkedItems,
        attachmentIds: this.attachmentIds,
        attachmentFieldName: this.attachmentFieldName
      }).then(() => {
        commonViewsUtil.showSuccess(this, "操作成功！");
        this.doQuery();
      })
    },
    openBatchUploadAttachmentModal() {
      const checkedCount = this.selectedItems.length
      if (checkedCount === 1) {
        this.attachmentIds = this.selectedItems[0][this.attachmentFieldName];
      } else {
        this.attachmentIds = ''
      }
      this.uploading = false
      this.$refs.batchUploadAttachment.showModal();
    },
    changeAttachmentIds(ids) {
      this.attachmentIds = ids;
    },
    changeUploading(uploading) {
      this.uploading = uploading;
    },
  }
}
</script>

<style scoped>

</style>
